
<template>
  <div>
    <tableComponents
      ref="tableComponents"
      :pagination="{
        currentPage: paginationForm.page,
        pageSize: paginationForm.page_size,
        total,
      }"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @sendUserSearch="getSearch"
      :searchData="payoutsSearchData"
      :isHaveExport="false"
      @toAdd="showEditDialog"
      :sizes="[15, 20, 50, 100]"
    >
      <template v-slot:table>
        <el-table :data="list" style="width: 100%" :border="true">
          <el-table-column prop="username" label="用户信息" align="center">
            <template v-slot="scope">
              <div class="user_user_info" v-if="scope.row.user">
                <!-- <img :src="scope.row.user.avatar" alt="" /> -->
                <div class="nickcname">{{ scope.row.user.nickname }}</div>
                <!-- <div class="nickcname">{{ scope.row.user.username }}</div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="username"
            width="110px"
            label="结账类型"
            align="center"
          >
            <template v-slot="scope">
              <el-tag type="success" v-if="scope.row.payouts_type == 1"
                >微信</el-tag
              >
              <el-tag v-else>支付宝</el-tag>

              <!-- <div v-if="scope.row.payouts_type != 1">
                <el-descriptions :column="1" :size="'mini'">
                  <el-descriptions-item label="支付宝姓名">
                    {{ scope.row.pay_name }}
                  </el-descriptions-item>
                  <el-descriptions-item label="支付宝账号">
                    {{ scope.row.pay_code }}
                  </el-descriptions-item>
                </el-descriptions>
              </div> -->
            </template>
          </el-table-column>
          <!-- <el-table-column prop="username" label="结账类型" align="center">
            <template v-slot="scope">
              <el-tag>{{ scope.row.pay_type }}</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column prop="money" label="结款金额" align="center">
            <template v-slot="scope">
              {{ Number(scope.row.money) }} ≈
              {{ Number(scope.row.money) / 100000 }}
            </template>
          </el-table-column>
          <el-table-column label="平台审核" align="center" width="110px">
            <template v-slot="scope">
              <el-tag type="success" v-if="scope.row.is_finish == 1"
                >已结款</el-tag
              >
              <el-tag type="danger" v-else-if="scope.row.is_finish == 2">
                已拒绝
              </el-tag>
              <el-tag type="warning" v-else-if="scope.row.is_finish == 3">
                打款失败
              </el-tag>
              <el-tag type="info" v-else>未结款</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="结算状态" align="center">
            <template v-slot="scope">
              {{ scope.row.msg }}
            </template>
          </el-table-column>
          <el-table-column label="申请时间" align="center">
            <template v-slot="scope">
              {{ $fnc.getTimeFormat(scope.row.created_time) }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="username" align="center" label="时间">
            <template v-slot="scope">
              <el-button
                v-if="scope.row.is_finish != 1"
                size="mini"
                icon="el-icon-check"
                type="primary"
                @click="checkPayouts(scope.row.id)"
              >
                审核结款
              </el-button>
              <div v-if="scope.row.is_finish == 1">
                <div>
                  结款时间： {{ $fnc.getTimeFormat(scope.row.pay_time) }}
                </div>
                <div v-if="scope.row.transDate">
                  到账时间： {{ scope.row.transDate }}
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="username" align="center" label="操作">
            <template v-slot="scope">
              <el-button
                v-if="scope.row.is_finish == 0"
                size="mini"
                icon="el-icon-check"
                type="primary"
                @click="checkPayouts(scope.row.id)"
              >
                审核结款
              </el-button>
              <el-button
                v-if="scope.row.is_finish == 1"
                size="mini"
                icon="el-icon-check"
                type="primary"
                disabled
              >
                已结款
              </el-button>
              <div v-if="scope.row.remark">
                {{ scope.row.remark }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </tableComponents>

    <el-dialog
      title="提现审核"
      :visible.sync="dialogVisible"
      width="30%"
      v-if="dialogVisible"
    >
      <el-descriptions
        class="margin-top"
        :title="payInfo.user.nickname + '-' + payInfo.user.username"
        :column="2"
        border
      >
        <el-descriptions-item>
          <template slot="label"> 提现类型 </template>
          {{ payInfo.payouts_type == 1 ? "微信" : "支付宝" }}
        </el-descriptions-item>
        <el-descriptions-item v-if="payInfo.payouts_type != 1">
          <template slot="label"> 支付宝姓名 </template>
          {{ payInfo.pay_name }}
        </el-descriptions-item>
        <el-descriptions-item v-if="payInfo.payouts_type != 1">
          <template slot="label"> 支付宝账号 </template>
          {{ payInfo.pay_code }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-wallet"></i>
            金额
          </template>
          {{ Number(payInfo.money) }} ≈
          {{ Number(payInfo.money) / 100000 }}
        </el-descriptions-item>
      </el-descriptions>
      <el-form ref="form" :model="payInfoForm" label-width="80px">
        <el-form-item label="打款方式">
          <el-radio-group v-model="payInfoForm.pay_type">
            <el-radio label="1">手动打款</el-radio>
            <el-radio label="2">公账打款</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否通过">
          <el-radio-group v-model="payInfoForm.is_finish">
            <el-radio label="1">通过</el-radio>
            <el-radio label="2">拒绝</el-radio>
            <el-radio label="3" disabled>打款失败</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="payInfoForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveCheckPayouts">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { payoutsSearchData } from "@/assets/js/searchData";
export default {
  data() {
    return {
      payoutsSearchData: payoutsSearchData,
      dialogVisible: false,
      list: [],
      queryForm: {},
      total: 0,
      formData: [],
      paginationForm: {
        page: 1,
        page_size: 15,
      },
      payInfo: {},
      payInfoForm: {
        is_finish: "1",
        pay_type: "2",
      },
    };
  },

  methods: {
    async checkPayouts(id) {
      let data = await this.$api.getPayouts.getPayoutsInfo({ id });
      this.payInfo = data.data;
      this.payInfoForm.id = data.data.id
      this.dialogVisible = true;
    },
    saveCheckPayouts() {
      this.dialogVisible = false;
      this.$swal({
        title: "审核用户提现",
        text: "是否提交数据结果",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async (willDelete) => {
        if (willDelete.value) {
          let { user, ...params } = this.payInfoForm;
          params.pay_time = (new Date().getTime() / 1000).toFixed(0);
          let data = await this.$api.getPayouts.saveCheckPayouts(params);
          if (data.code == 200) {
            this.$message.success(data.msg);
            this.dialogVisible = false;
          }

          this.getPayoutsList();
        }
      });
    },
    async getPayoutsList() {
      let data = await this.$api.getPayouts.getPayoutsList({
        ...this.paginationForm,
        ...this.queryForm,
      });
      this.total = data.data.count;
      this.list = data.data.list;
    },

    handleCurrentChange(val) {
      this.paginationForm.page = val;
      this.getPayoutsList();
    },
    handleSizeChange(val) {
      this.paginationForm.page_size = val;
      this.getPayoutsList();
    },
    getSearch(e) {
      this.queryForm = e;
      this.getPayoutsList();
    },
    showEditDialog() {
      this.$refs.appDialogRef.openDialog("新增APP");
    },

    toUp(username) {
      this.$refs.tableComponents.clearSearch();
      this.getUserSearch({ username });
    },
    getUserSearch(obj) {
      this.paginationForm.page = 1;
      this.queryForm = obj;
      this.getPayoutsList();
    },
  },
  created() {
    this.getPayoutsList();
  },
  components: {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.user_user_info {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .nickcname {
    background-color: #409eff;
    color: #fff;
    border-radius: 5px;
    width: max-content;
    padding: 0 5px;
    margin-top: 5px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
.fx {
  justify-content: center;
  margin-top: 3px;
  .text {
    width: 60px;
    min-width: max-content;
    flex: 1;
    text-align: left;
  }
}
/deep/ .el-table .el-table__cell {
  padding: 5px 0;
}
</style>